var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackAiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.25 60.4167H113.363C109.722 44.1401 95.1867 31.9167 77.8333 31.9167H66.75V27.8634C72.26 25.9001 76.25 20.6751 76.25 14.5001C76.25 6.64672 69.8533 0.250058 62 0.250058C54.1467 0.250058 47.75 6.64672 47.75 14.5001C47.75 20.6751 51.74 25.9001 57.25 27.8634V31.9167H46.1667C28.8133 31.9167 14.2783 44.1401 10.6367 60.4167H9.75C4.525 60.4167 0.25 64.6917 0.25 69.9167V79.4167C0.25 84.6417 4.525 88.9167 9.75 88.9167H11.4917C15.2283 100.57 24.665 109.627 36.5083 112.92C35.6217 114.788 35.0833 116.815 35.0833 119C35.0833 121.628 37.205 123.75 39.8333 123.75H84.1667C86.795 123.75 88.9167 121.628 88.9167 119C88.9167 116.815 88.3783 114.757 87.4917 112.92C99.335 109.658 108.772 100.57 112.508 88.9167H114.25C119.475 88.9167 123.75 84.6417 123.75 79.4167V69.9167C123.75 64.6917 119.475 60.4167 114.25 60.4167ZM62 9.75006C64.6283 9.75006 66.75 11.8717 66.75 14.5001C66.75 17.1284 64.6283 19.2501 62 19.2501C59.3717 19.2501 57.25 17.1284 57.25 14.5001C57.25 11.8717 59.3717 9.75006 62 9.75006ZM77.8333 104.75H46.1667C31.315 104.75 19.25 92.6851 19.25 77.8334V68.3334C19.25 53.4817 31.315 41.4167 46.1667 41.4167H77.8333C92.685 41.4167 104.75 53.4817 104.75 68.3334V77.8334C104.75 92.6851 92.685 104.75 77.8333 104.75Z",
    fill: "url(#paint0_linear_8945_394)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5833 54.0834C39.3583 54.0834 35.0833 58.3584 35.0833 63.5834V73.0834C35.0833 78.3084 39.3583 82.5834 44.5833 82.5834C49.8083 82.5834 54.0833 78.3084 54.0833 73.0834V63.5834C54.0833 58.3584 49.8083 54.0834 44.5833 54.0834Z",
    fill: "url(#paint1_linear_8945_394)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4167 54.0834C74.1917 54.0834 69.9167 58.3584 69.9167 63.5834V73.0834C69.9167 78.3084 74.1917 82.5834 79.4167 82.5834C84.6417 82.5834 88.9167 78.3084 88.9167 73.0834V63.5834C88.9167 58.3584 84.6417 54.0834 79.4167 54.0834Z",
    fill: "url(#paint2_linear_8945_394)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.845 9.49673L38.345 12.6634C38.8517 12.8217 39.3583 12.9167 39.8333 12.9167C41.8283 12.9167 43.665 11.6501 44.33 9.65506C45.1533 7.15339 43.8233 4.46173 41.3217 3.63839L31.8217 0.471725C29.3517 -0.351608 26.66 0.978391 25.805 3.48006C24.95 5.98172 26.3117 8.67339 28.8133 9.49673H28.845Z",
    fill: "url(#paint3_linear_8945_394)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3333 28.7501C30.84 28.7501 31.3467 28.6867 31.8217 28.4967L41.3217 25.3301C43.8233 24.5067 45.1533 21.8151 44.33 19.3134C43.5067 16.8117 40.815 15.4817 38.3133 16.3051L28.8133 19.4717C26.3117 20.2951 24.9817 22.9867 25.805 25.4884C26.47 27.4834 28.3067 28.7501 30.3017 28.7501H30.3333Z",
    fill: "url(#paint4_linear_8945_394)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1667 12.9167C84.6733 12.9167 85.18 12.8534 85.655 12.6634L95.155 9.49673C97.6567 8.67339 98.9867 5.98172 98.1633 3.48006C97.34 0.978391 94.6483 -0.351608 92.1467 0.471725L82.6467 3.63839C80.145 4.46173 78.815 7.15339 79.6383 9.65506C80.3033 11.6501 82.14 12.9167 84.135 12.9167H84.1667Z",
    fill: "url(#paint5_linear_8945_394)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6783 25.3301L92.1783 28.4967C92.685 28.6551 93.1917 28.7501 93.6667 28.7501C95.6617 28.7501 97.4983 27.4834 98.1633 25.4884C98.9867 22.9867 97.6567 20.2951 95.155 19.4717L85.655 16.3051C83.185 15.4817 80.4617 16.8117 79.6383 19.3134C78.815 21.8151 80.145 24.5067 82.6467 25.3301H82.6783Z",
    fill: "url(#paint6_linear_8945_394)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8945_394",
    x1: 0.25,
    y1: 61.9892,
    x2: 145.395,
    y2: 61.9584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFACE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8945_394",
    x1: 0.25,
    y1: 61.9892,
    x2: 145.395,
    y2: 61.9584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFACE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8945_394",
    x1: 0.25,
    y1: 61.9892,
    x2: 145.395,
    y2: 61.9584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFACE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8945_394",
    x1: 0.25,
    y1: 61.9892,
    x2: 145.395,
    y2: 61.9584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFACE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8945_394",
    x1: 0.25,
    y1: 61.9892,
    x2: 145.395,
    y2: 61.9584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFACE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8945_394",
    x1: 0.25,
    y1: 61.9892,
    x2: 145.395,
    y2: 61.9584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFACE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8945_394",
    x1: 0.25,
    y1: 61.9892,
    x2: 145.395,
    y2: 61.9584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFACE3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackAiIcon);
export default __webpack_public_path__ + "static/media/black-ai-icon.8158ab716b943f05eb3bb0d863609efa.svg";
export { ForwardRef as ReactComponent };